import React, { useEffect } from 'react';
import { Outlet, useNavigate, generatePath } from 'react-router-dom';
import { ROUTES } from 'routes/routes';
import { usePermissionChecker } from 'hooks/usePermissionChecker';
import { PermissionActions, PermissionModules } from 'types/rolesTypes';

interface ProtectedRouteProps {
  moduleName: PermissionModules;
  action?: PermissionActions;
  fallback?: JSX.Element;
  children?: JSX.Element;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  moduleName,
  action = PermissionActions.Read,
  fallback = <div></div>,
  children,
}) => {
  const navigate = useNavigate();
  const checkPermission = usePermissionChecker();
  const hasPermission = checkPermission(moduleName, action);

  useEffect(() => {
    if (hasPermission === false) {
      navigate(generatePath(ROUTES.HOME));
    }
  }, [hasPermission, navigate]);

  if (hasPermission === null) {
    return fallback;
  }

  // Render the children if provided, otherwise render an Outlet for nested routes.
  return children || <Outlet />;
};

export default ProtectedRoute;
